import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import { api } from "../../../config";
import ModalImage from "react-modal-image";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { getEventLoading, getEvents as onGetEvents, getCategories as onGetCategories, addNewEvent as onAddNewEvent, deleteEvent as onDeleteEvent, updateEvent as onUpdateEvent, resetCalendar } from "../../../store/calendar/action";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const Event = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, events, loading, categories, isEventUpdated, isEventLoaded, employees, employeeLoading, clients, clientLoading, companies, companyLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    events: state.Calendar.events,
    loading: state.Calendar.loading,
    categories: state.Calendar.categories,
    isEventUpdated: state.Calendar.isEventUpdated,
    isEventLoaded: state.Calendar.isEventLoaded,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
  }));

  const [logo, setLogo] = useState(defaultImg);
  const [eventList, setEventList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [event, setEvent] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [taskFiles, setTaskFiles] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");
  const [employeeSelect, setEmployeeSelect] = useState(null);
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [pageIdx, setPageIdx] = useState(0);
  const [eventDoc, setEventDoc] = useState([]);

  const [statusActive, setStatusActive] = useState([]);
  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];
  const onClickDelete = (event) => {
    setEvent(event);
    setDeleteModal(true);
  };

  const handleDeleteEvent = () => {
    if (event) {
      dispatch(onDeleteEvent(event));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isEmpty(events)) {
      let filteredEvents = events;
      if (activeTypeTab !== "all") {
        filteredEvents = events.filter((event) => event.event_status.name === activeTypeTab);
      }
      setEventList(filteredEvents.map((el) => ({ ...el, isChecked: false })));
    }
  }, [events]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "permission_user",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "name",
        label: "Alasan",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
      {
        id: "start",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "statusId",
        label: "Status",
        isSelected: true,
        data: [],
      },
    ];

    if (eventList.length > 0) {
      eventList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "permission_user") {
                doc.data.push(value?.name ?? "-");
              } else if (doc.id === "statusId") {
                switch (value) {
                  case 1:
                    doc.data.push("DRAFT");
                    break;
                  case 2:
                    doc.data.push("ACTIVE");
                    break;
                  default:
                    doc.data.push("INACTIVE");
                    break;
                }
              } else {
                doc.data.push(value);
              }
            } else {
              if (key === "extendedProps") {
                if (data.extendedProps.statusId) {
                  const status = dataDoc.find((d) => d.id === "statusId");
                  switch (value) {
                    case 1:
                      status.data.push("DRAFT");
                      break;
                    case 2:
                      status.data.push("ACTIVE");
                      break;
                    default:
                      status.data.push("INACTIVE");
                      break;
                  }
                }

                if (data.extendedProps.name) {
                  const name = dataDoc.find((d) => d.id === "name");
                  const permissionUser = dataDoc.find((d) => d.id === "permission_user");
                  name.data.push(value.name ?? "-");
                  permissionUser.data.push(value.permission_user.name ?? "-");
                }
              }
            }
          });
        }
      });
    }

    setEventDoc(dataDoc);
  }, [eventList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredEvents = events;
      if (type !== "all") {
        filteredEvents = events.filter((event) => event.event_status.name === type);
      }
      setEventList(filteredEvents);
    }
  };

  useEffect(() => {
    if (companySelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(onGetCategories());
      dispatch(onGetEvents({ companyId: companySelected?.value ?? "" }));
      handleGetEmployee(companySelected?.value ?? "");
    }
  }, [companySelected]);

  const handleGetEmployee = (id) => {
    dispatch(resetEmployeeState());
    dispatch(getEmployee({ companyId: id }));
  };

  useEffect(() => {
    if (!isEmpty(categories)) {
      var dataTimeoff = [];
      var dataOvertime = [];
      var dataOther = [];
      var dataAll = [];
      var optTimeoff = [];
      var optOvertime = [];
      var optOther = [];
      var optAll = [];
      categories.data.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        if (item.type !== "attendance") {
          optAll.push(obj);
        }

        if (item.type === "timeoff") {
          optTimeoff.push(obj);
        } else if (item.type === "overtime") {
          optOvertime.push(obj);
        } else if (item.type === "general") {
          optOther.push(obj);
        }
      });

      // dataTimeoff.push({ options: optTimeoff });
      // setTimeOff(dataTimeoff);
      // dataOvertime.push({ options: optOvertime });
      // setOvertime(dataOvertime);
      // dataOther.push({ options: optOther });
      // setOtherEvent(dataOther);
      dataAll.push({ options: optAll });
      // setAllevent(dataAll);
      setCategoryList(dataAll);
    }
  }, [categories]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    employees.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      const userId = item.userId;
      var obj = { label: name, value: id, userId: userId };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (employees.length > 0) {
      setEmployeeList(data);
    }
  }, [employees]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setEvent(null);
      validation.resetForm();
      validation.setErrors({});
      setTaskFiles([]);
    } else {
      setModal(true);
    }
  }, [dispatch, modal]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = taskFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setTaskFiles(newState);
    } else {
      const index = taskFiles.findIndex((fl) => fl.filename === file.filename);
      setTaskFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleSelectFile = (file) => {
    setTaskFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  const handleApproveEmployee = () => {
    if (event) {
      event.setApprove = true;
      event.canApprove = false;
      dispatch(onUpdateEvent(event));
      setApproveModal(false);
      setModal(false);
    }
  };

  const handleEventClick = useCallback(
    (arg) => {
      const ev = arg;
      let files = [];

      if (ev.permission_category) {
        let files = [];
        for (const f of ev.permission_file) {
          files.push({ filename: f.filename, originalname: f.originalname });
        }
        setTaskFiles(files);

        setEvent({
          client: ev.permission_client && {
            label: ev.permission_client ? ev.permission_client.name : "",
            value: ev.permission_client ? ev.permission_client.id : "",
          },
          company: ev.permission_company && {
            label: ev.permission_company ? ev.permission_company.name : "",
            value: ev.permission_company ? ev.permission_company.id : "",
          },
          id: ev.id,
          title: ev.name,
          name: ev.name,
          permission_category: ev.permission_category,
          startat: ev.startat,
          endat: ev.endat,
          className: ev.permission_category.classname,
          type: { label: ev.permission_category.name, value: ev.permission_category.id, type: ev.permission_category.type },
          description: ev.description,
          location: ev.location,
          path: ev.permission_file,
          employee: { label: ev.permission_user.name, value: ev.permission_user.id, companyId: ev.permission_user.companyId },
          canApprove: ev.canApprove,
        });
      }

      setIsEdit(true);
      toggle();
    },
    [toggle, userType]
  );

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteEvent(element.value));
    });
    checkall.checked = false;
  };

  const onClickApprove = (employee) => {
    setEvent(employee);
    setApproveModal(true);
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = eventList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setEventList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cell) => {
          let data = cell.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = eventList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setEventList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateEvent") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleEventClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteEvent") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  {cell.row.original.canApprove && cell.row.original.hasApprove === false && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approveEvent") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `Anda akan menyetujui perizinan untuk ${data.permission_user.name}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Karyawan",
        accessor: "extendedProps.permission_user.name",
        filterable: true,
      },
      {
        Header: "Alasan",
        accessor: "extendedProps.name",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "extendedProps.description",
        filterable: true,
      },
      {
        Header: "Lampiran",
        accessor: "extendedProps.permission_file",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original.extendedProps;
          return (
            <div className="row mt-3">
              {(data.permission_file || []).map((f, i) => {
                return (
                  <div key={i} className="col-lg-4">
                    <div className="position-relative d-inline-block mx-auto">
                      <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-lg img-thumbnail user-profile-image" />
                    </div>
                  </div>
                );
              })}
            </div>
          );
        },
      },
      {
        Header: "Tanggal",
        accessor: "start",
        filterable: true,
        Cell: (rates) => <> {handleValidDate(rates.row.original.start)} </>,
      },
      {
        Header: "Status",
        accessor: "event_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.extendedProps.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">INACTIVE</span>;
          }
        },
      },
    ],
    [eventList, handleEventClick, userType, userRole, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = eventList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setEventList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => eventList, [eventList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var reason = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      reason: reason,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetEvents(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setEventList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(onGetEvents({ companyId: companySelected?.value ?? "" }));
  };

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      client: (event && event.client) || clientSelected,
      company: (event && event.company) || companySelected,
      name: (event && event.name) ?? "",
      location: (event && event.location) ?? "",
      description: (event && event.description) ?? "",
      startat: (event && event.startat) ?? "",
      endat: (event && event.endat) ?? "",
      type: event && event.type,
      employee: (event && event.employee) || employeeSelect,
    },

    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Your Event Name"),
      startat: Yup.string().required("Please Enter Your Event Start Date"),
      endat: Yup.string().required("Please Enter Your Event End Date"),
      type: Yup.object().required("Please Select Your Category"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        let newTask = {
          id: event ? event.id : 0,
          permissionCategoryId: values.type.value,
          startat: values.startat,
          endat: values.endat,
          description: values.description,
          location: values.location,
          name: values.name,
          clientId: values.client.value,
          companyId: values.company.value,
          userId: values.employee.value,
          files: taskFiles.length > 0 ? taskFiles : [],
        };
        dispatch(onUpdateEvent(newTask));
        validation.resetForm();
      } else {
        let newTask = {
          permissionCategoryId: values.type.value,
          startat: values.startat,
          endat: values.endat,
          description: values.description,
          location: values.location,
          name: values.name,
          clientId: values.client.value,
          companyId: values.company.value,
          userId: values.employee.value,
          files: taskFiles.length > 0 ? taskFiles : [],
        };
        dispatch(onAddNewEvent(newTask));
        validation.resetForm();
      }
      toggle();
    },
  });

  document.title = "Perizinan | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={eventList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteEvent} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <ApproveModal data={event && event.permission_user ? event.permission_user.name : ""} show={approveModal} onApproveClick={handleApproveEmployee} onCloseClick={() => setApproveModal(false)} />

      <Container fluid>
        <BreadCrumb title="Penggajian" pageTitle="Perizinan" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createEvent") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-user-unfollow-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={eventDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteEvent") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Hapus
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="eventList">
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-user-unfollow-line me-1 align-bottom fs-14"></i>SEMUA PERIZINAN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>

                          <Col sm={3}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={3}>
                            <div className="me-2 mb-2 col-12">
                              <Select
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  setStatusActive(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal isOpen={modal} id="event-modal" centered size="lg">
                  <ModalHeader toggle={toggle} tag="h5" className="p-3 bg-soft-info modal-title">
                    {!!isEdit ? "Edit Jadwal Kalender" : "Tambah Perizinan"}
                  </ModalHeader>
                  <ModalBody>
                    <Form
                      name="event-form"
                      id="form-event"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="event-details">
                        <div className="d-flex mb-2">
                          <div className="flex-grow-1 d-flex align-items-center">
                            <div className="flex-shrink-0 me-3">
                              <i className="ri-calendar-event-line text-muted fs-16"></i>
                            </div>
                            <div className="flex-grow-1">
                              <h6 className="d-block fw-semibold mb-0" id="event-start-date-tag">
                                {event ? handleValidDate(event.startat) + " to " + handleValidDate(event.endat) : ""}
                              </h6>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <div className="flex-shrink-0 me-3">
                            <i className="ri-map-pin-line text-muted fs-16"></i>
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="d-block fw-semibold mb-0">
                              <span id="event-location-tag">{event && event.location ? event.location : "No Location"}</span>
                            </h6>
                          </div>
                        </div>
                        <div className="d-flex mb-3">
                          <div className="flex-shrink-0 me-3">
                            <i className="ri-discuss-line text-muted fs-16"></i>
                          </div>
                          <div className="flex-grow-1">
                            <h5>{event && event.permission_category !== undefined ? event.permission_category.name : ""}</h5>
                            <p className="d-block text-muted mb-0" id="event-description-tag">
                              {event && event.description !== undefined ? event.description : "No Description"}
                            </p>
                            <p className="d-block text-muted mb-0" id="event-description-tag">
                              {event && event.title}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex row mb-3">
                          <div className="flex-grow-1 col-lg-6">
                            {taskFiles.map((taskFile, i) => {
                              return (
                                <div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      <img src={taskFile.filename === "" ? logo : `${api.MEDIA_URL}/media/${taskFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="img-fluid" />
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                            {event && event.path ? <img src={process.env.REACT_APP_API_URL + "/files/" + event.path.path} alt="" className="img-fluid" /> : ""}
                          </div>
                        </div>
                      </div>
                      <div className="event-form">
                        <div className="row">
                          <div className="mb-3 col-lg-6">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3 col-lg-6">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setBranchSelect(null));
                                dispatch(setCompanySelect(e));
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3 col-lg-6">
                            <Label htmlFor="employee-field" className="form-label">
                              Karyawan <span className="text-danger">*</span>&nbsp;
                              {employeeLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="employee"
                              value={validation.values.employee}
                              placeholder="Pilih Karyawan"
                              isDisabled={userType === "admin" || userType === "client" || (userRole && userRole.split(",").indexOf("approvePermissionStaff") < 0) ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("oldposition", e.position);
                                validation.setFieldValue("employee", e);
                              }}
                              options={employeeList}
                            ></Select>
                            {validation.touched.employee && validation.errors.employee ? (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validation.errors.employee}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3 col-lg-6">
                            <Label className="form-label">Kategori</Label>
                            <Select
                              name="type"
                              value={validation.values.type}
                              placeholder="Pilih Kategori"
                              onChange={(e) => {
                                validation.setFieldValue("type", e);
                              }}
                              options={categoryList}
                            ></Select>
                            {validation.touched.type && validation.errors.type ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.type}
                              </small>
                            ) : null}
                          </div>
                        </div>

                        <div className={"row"}>
                          <div className="mb-3 col-lg-6">
                            <Label className="form-label">Nama Acara</Label>
                            <Input className={"form-control d-block"} placeholder="Isi Nama Acara" type="text" name="name" id="event-title" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} />
                            {validation.touched.name && validation.errors.name ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.name}
                              </small>
                            ) : null}
                          </div>
                          <div className="mb-3 col-lg-3">
                            <Label>Tanggal Mulai</Label>
                            <div className={"input-group"}>
                              <Flatpickr
                                name="startat"
                                className="form-control"
                                placeholder="Tanggal Mulai"
                                options={{ enableTime: true, time_24hr: true, altInput: true, altFormat: "Y/m/d H:i", dateFormat: "Y/m/d H:i" }}
                                value={validation.values.startat ?? ""}
                                onChange={(obj, str) => {
                                  validation.setFieldValue("startat", str);
                                }}
                              />
                              {validation.touched.startat && validation.errors.startat ? (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.startat}
                                </small>
                              ) : null}
                              <span className="input-group-text">
                                <i className="ri-calendar-event-line"></i>
                              </span>
                            </div>
                          </div>
                          <div className="mb-3 col-lg-3">
                            <Label>Tanggal Berakhir</Label>
                            <div className={"input-group"}>
                              <Flatpickr
                                name="endat"
                                className="form-control"
                                placeholder="Tanggal Berakhir"
                                options={{ enableTime: true, time_24hr: true, altInput: true, altFormat: "Y/m/d H:i", dateFormat: "Y/m/d H:i" }}
                                value={validation.values.endat ?? ""}
                                onChange={(obj, str) => {
                                  validation.setFieldValue("endat", str);
                                }}
                              />
                              {validation.touched.endat && validation.errors.endat ? (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.endat}
                                </small>
                              ) : null}
                              <span className="input-group-text">
                                <i className="ri-calendar-event-line"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-lg-12">
                            <Label htmlFor="event-location">Lokasi</Label>
                            <Input type="text" className={"form-control d-block"} name="location" id="event-location" placeholder="Isi Nama Lokasi" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.location ?? ""} />
                            {validation.touched.location && validation.errors.location ? <FormFeedback type="invalid">{validation.errors.location}</FormFeedback> : null}
                          </div>
                          <div className="col-lg-12 mb-3">
                            <div className="mb-3 d-flex justify-content-between">
                              <Label htmlFor="taskFiles" className="form-label me-3">
                                Berkas Perizinan
                              </Label>
                              <button
                                type="button"
                                className="btn btn-sm btn-label btn-soft-success"
                                onClick={() => {
                                  toggleMedia();
                                }}
                              >
                                <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                              </button>
                            </div>
                            {taskFiles.map((taskFile, i) => {
                              if (taskFile.isDeleted) {
                                return null;
                              } else {
                                return (
                                  <div key={i} className="border-bottom mb-3">
                                    <div className="d-flex justify-content-between mb-3 align-items-center">
                                      <div className="me-2">
                                        <img src={taskFile.filename === "" ? logo : `${api.MEDIA_URL}/media/${taskFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                      </div>

                                      <div className="text-truncate">{taskFile.filename}</div>
                                      <div>
                                        <Link
                                          to="#"
                                          className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                          onClick={(e) => {
                                            handleDeleteFile(taskFile);
                                          }}
                                        >
                                          <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Keterangan</Label>
                          <textarea className={"form-control d-block"} id="event-description" name="description" placeholder="Isi Keterangan" rows="3" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description}></textarea>
                          {validation.touched.description && validation.errors.description ? <FormFeedback type="invalid">{validation.errors.description}</FormFeedback> : null}
                        </div>
                      </div>
                      <div className="hstack gap-2 justify-content-end">
                        <p>&nbsp;</p>
                        <button type="submit" id="btn-save-event" className={!!isEdit ? "d-none btn btn-success" : "d-block btn btn-success"}>
                          {!!isEdit ? "Edit Event" : "Tambah Perizinan"}
                        </button>
                      </div>
                    </Form>
                  </ModalBody>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Event;
